<div>
  <form [formGroup]="formGroup" (submit)="onSubmit()">
    <app-input-text
      [config]="formFields.email"
      formControlName="email"
    ></app-input-text>
    <app-input-password
      [config]="formFields.password"
      formControlName="password"
    ></app-input-password>

    <app-button
      type="submit"
      [loading]="loaders[Loaders.Login]"
      classname="btn-primary btn-lg px-5"
    >ZALOGUJ SIĘ</app-button>
  </form>
</div>


